require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/get-iterator.js
 ** module id = 317
 ** module chunks = 0
 **/